import { Button, Input, Modal, Table } from "antd"
import { useState, useEffect, useRef } from "react";
import axios from "axios"
import { DeleteOutlined } from "@ant-design/icons";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;

function GuideList() {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([])
  const [dataSourceOrigin, setDataSourceOrigin] = useState([])
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [5, 10, 20],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 10, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
    filters: {},
  });
  const column = [
    {
      title: "order",
      dataIndex: "order",
      key: "order",
      width: "50px"
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      width: "200px",
      render: (_,record)=><Input value={_} defaultValue={_} onChange={e=>{titleChange(e,record)}} onBlur={changeHandler}/>
    },
    {
      title: "content",
      dataIndex: "content",
      key: "content",
      render: (_,record)=><Input.TextArea value={_} defaultValue={_} onChange={e=>{contentChange(e,record)}} onBlur={changeHandler}/>
    },
    {
      width: "20px",
      render: (_) => <a onClick={() => deleteHandler(_)}>{<DeleteOutlined />}</a>,
    },
  ];

  const getDataSource = async () => {

    const data = await axios.get(`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/guides.json`)

    // const data = await axios.get(`${backend}/static/test.json`)
    const sourceData = data.data.map((el,idx)=>{
      el.order = idx +1
      return el
    })

    setDataSource(sourceData)
    setDataSourceOrigin(JSON.parse(JSON.stringify(sourceData)))
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: data.length, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  }

  const contentChange = (e,record) => {
    const newContent = e.target.value
    const instance = dataSource.slice()
    instance[record.order-1].content = newContent
    setDataSource(instance)
  }

  const titleChange = (e,record) => {
    const newTitle = e.target.value
    const instance = dataSource.slice()
    instance[record.order-1].title = newTitle
    setDataSource(instance)
  }

  const changeHandler = () => {
    const data = dataSource.slice()
    const data2 = JSON.stringify(data)
    
    s3Controller.s3Upload2(data2,"guides.json",(err,data)=>{
      if(err) {
        Modal.error({
          title:"에러",
          content:"저장하지 못했습니다.",
          okText:"확인",
          afterClose: ()=>{setDataSource(JSON.parse(JSON.stringify(dataSourceOrigin)))}
        })
      } else {
        setDataSourceOrigin(JSON.parse(JSON.stringify(data)))
      }
    })
  }

  const insert = () => {
    const data = dataSource.slice()
    data.unshift({title: "", content: '', order: 1})
    const data2 = data.map((el,idx)=>{
      el.order = idx +1
      return el
    })
    setDataSource(data2)
  }

  const deleteHandler = (_) =>{
    const data = dataSource.slice()
    data.splice(_.order-1,1)
    const data2 = data.map((el,idx)=>{
      el.order = idx + 1
      return el
    })
    const data3 = JSON.parse(JSON.stringify(data2)).map(el=>{
      delete el.order
      return el
    })
    const data4 = JSON.stringify(data3)

    s3Controller.s3Upload2(data4,"guides.json",(err,data)=>{
      if(err) {
        Modal.error({
          title:"에러",
          content:"삭제하지 못했습니다.",
          okText:"확인",
        })
      } else {
        setDataSource(data2)
        setDataSourceOrigin(JSON.parse(JSON.stringify(data2)))
      }
    })
  }

 
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      ...tableParams,
      pagination,
    });
    // if (pagination.pageSize !== tableParams.pagination?.pageSize) {
    //   setSourceDataKor([]);
    // }
  };

  useEffect(()=>{
    getDataSource()
  },[JSON.stringify(tableParams)])

  return (
    <div>
      <div style={{textAlign:"right"}}>
      <Button onClick={insert}>항목추가</Button>
      </div>
      <Table
        columns={column}
        rowKey="order"
        dataSource={dataSource}
        loading={loading}
        pagination={tableParams.pagination}
        onChange={handleTableChange}
      />
    </div>
  );
}

export default GuideList;
